'use client';

import React__default, { useState } from 'react';
import BottomSheet from '../../../BottomSheet/index.js';
import { BottomSheetOptions, BottomSheetOptionItem } from '../../ButtonViewMore.css.js';

var ResponsiveSheet = function (props) {
    var options = props.options, textOptions = props.textOptions, responsiveButton = props.responsiveButton, isShow = props.isShow, setIsShow = props.setIsShow, _a = props.header, header = _a === void 0 ? '' : _a, _b = props.sheetStyles, sheetStyles = _b === void 0 ? {} : _b, _c = props.mode, mode = _c === void 0 ? 'vertical' : _c;
    var _d = useState(isShow), isChildShow = _d[0], setChildShow = _d[1];
    return (React__default.createElement(BottomSheet, { styleOption: sheetStyles, onClose: function () { return setIsShow(false); }, isOpen: isChildShow, options: {
            isHaveCloseIcon: false
        }, header: header, footerOptions: {
            text: textOptions.closeText,
            buttonType: responsiveButton.type || 'default'
        } },
        React__default.createElement(BottomSheetOptions, { mode: mode }, options.map(function (item, index) {
            return (React__default.createElement(BottomSheetOptionItem, { key: "item-".concat(index), mode: mode, onClick: function () {
                    if (item.isDisabled)
                        return;
                    // Close dropdown on click
                    item.isCloseOnClick && setChildShow(false);
                    // callback onClick function
                    item.onClick && item.onClick();
                }, isDisabled: !!item.isDisabled },
                item.icon ? React__default.createElement("span", null, item.icon) : null,
                React__default.createElement("div", null, item.label)));
        }))));
};

export { ResponsiveSheet as default };
//# sourceMappingURL=index.js.map
